import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { hoaDonDienTuApi } from "../../../api/hoa-don/hoaDonDienTuApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  IHoaDonDieuChinhThuCongHuyRequest,
  IHoaDonDieuChinhThuCongSaveRequest,
  IHoaDonDieuChinhThuCongSelectRequest,
  IHoaDonDieuChinhThuCongTarget,
} from "../../../model/respone/hoa-don-dien-tu/IHoaDonDieuChinhThuCong";
import {
  eHoaDonDieuChinhThuCongActionIds,
  IHoaDonDieuChinhThuCongActionTypes,
} from "../../action-types/hoa-don/IHoaDonDieuChinhThuCongAction";
import { rootActions } from "../../actions/rootActions";

export function* hoaDonDieuChinhThuCongSaga(): any {
  yield takeLatest(eHoaDonDieuChinhThuCongActionIds.SHOW_MODAL, showModalWorker);
  yield takeLatest(eHoaDonDieuChinhThuCongActionIds.LOAD_START, loadWorker);
  yield takeEvery(eHoaDonDieuChinhThuCongActionIds.SAVE_START, saveWorker);
  yield takeEvery(eHoaDonDieuChinhThuCongActionIds.HUY_START, huyWorker);
}

// Mở ô điều chỉnh là nạp luôn lịch sử của đúng hóa đơn đó.
function* showModalWorker(action: IHoaDonDieuChinhThuCongActionTypes): any {
  const target = action.payload as IHoaDonDieuChinhThuCongTarget;
  yield put(
    rootActions.hoaDon.hoaDonDieuChinhThuCong.LOAD_START({
      loai: target.loai,
      id: target.id,
      ky_hieu: target.ky_hieu,
    }),
  );
}

function* loadWorker(action: IHoaDonDieuChinhThuCongActionTypes): any {
  const res: IBaseRespone = yield call(
    hoaDonDienTuApi.SelectDieuChinhThuCong,
    action.payload as IHoaDonDieuChinhThuCongSelectRequest,
  );
  if (res.is_success) {
    yield put(rootActions.hoaDon.hoaDonDieuChinhThuCong.LOAD_SUCCESS(res.data ?? []));
  } else {
    yield put(
      rootActions.hoaDon.hoaDonDieuChinhThuCong.LOAD_ERROR(res.message ?? "Không tải được lịch sử điều chỉnh"),
    );
  }
}

function* saveWorker(action: IHoaDonDieuChinhThuCongActionTypes): any {
  const res: IBaseRespone = yield call(
    hoaDonDienTuApi.InsertDieuChinhThuCong,
    action.payload as IHoaDonDieuChinhThuCongSaveRequest,
  );
  if (res.is_success) {
    yield put(rootActions.hoaDon.hoaDonDieuChinhThuCong.SAVE_SUCCESS(res.data ?? []));
  } else {
    yield put(rootActions.hoaDon.hoaDonDieuChinhThuCong.SAVE_ERROR(res.message ?? "Không lưu được điều chỉnh"));
  }
}

function* huyWorker(action: IHoaDonDieuChinhThuCongActionTypes): any {
  const res: IBaseRespone = yield call(
    hoaDonDienTuApi.HuyDieuChinhThuCong,
    action.payload as IHoaDonDieuChinhThuCongHuyRequest,
  );
  if (res.is_success) {
    yield put(rootActions.hoaDon.hoaDonDieuChinhThuCong.HUY_SUCCESS(res.data ?? []));
  } else {
    yield put(rootActions.hoaDon.hoaDonDieuChinhThuCong.HUY_ERROR(res.message ?? "Không hủy được"));
  }
}
